import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags.js'
import * as nodes from '/vercel/path0/markdoc/nodes/index.js'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer();

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ndescription: Documentation of the geOps Maps API. Create beautiful maps using Mapbox vector tiles.\nicon: map-trifold\ntitle: Maps\nsubtitle: Public transport maps\nweight: 2\n---\n\nOur maps are based on Mapbox vector tiles. This technology allows high-performance maps and enables unlimited possibilities for styling and interactivity. With the same basics, the maps can look very different and be optimally adapted to your corporate design or your special application.\n\nOur maps emphasize everything that is relevant for public transport and mobility in general. Besides the nice looking cartography the following features are the highlights:\n\n- Complete stations and stops with official names and official numbering.\n- Stop edges as point objects as well as polygons for the platforms.\n- Lines of public transport for trains, buses, trams and other means of transport.\n- Points of Interest (POIs) with the offers of Shared Mobility.\n- House numbers as well as entrances and passages as orientation points for door-to-door navigation.\n- Elements important for barrier-free navigation, such as lifts and escalators.\n\nHere are examples of some map styles we offer. Contact us if you need individual styles.\n\n{% map-tiles-grid /%}\n\nIn order to include a map you have to reference the style together with the key.\n`https://maps.geops.io/styles/base_bright_v2/style.json?key=<key>`\n\nCheck the {% link href=\"/guides\" %}guides{% /link %} section to learn how to add our maps to your application.\n";
const filepath = "/apis/maps.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
